export default __webpack_public_path__ + "static/media/phone.cc9c6ef4.svg";